



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETSTAKENOWSECTIONBYID
// GETSTAKENOWSECTIONBYID


const GETSTAKENOWSECTIONBYID= createAsyncThunk(
  "getStakeNowSectionById/getStakeNowSectionById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getStakeNowSectionByIdSlice = createSlice({
  name: "getStakeNowSectionByIdSlice",
  initialState: {
    getStakeNowSectionById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetStakeNowSectionById: (state) => {
        state.getStakeNowSectionById.loading = false
        state.getStakeNowSectionById.error = false
        state.getStakeNowSectionById.data = []
        state.getStakeNowSectionById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETSTAKENOWSECTIONBYID.fulfilled, (state, action) => {
      state.getStakeNowSectionById = {
        ...state.getStakeNowSectionById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETSTAKENOWSECTIONBYID.pending, (state, action) => {
      state.getStakeNowSectionById = {
        ...state.getStakeNowSectionById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETSTAKENOWSECTIONBYID.rejected, (state, action) => {
      state.getStakeNowSectionById = {
        ...state.getStakeNowSectionById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getStakeNowSectionByIdAction = {
    GETSTAKENOWSECTIONBYID,
};

export { getStakeNowSectionByIdAction };
export default getStakeNowSectionByIdSlice.reducer;
export const {setInitialStateOfgetStakeNowSectionById} = getStakeNowSectionByIdSlice.actions
